import {
  Building2,
  CandlestickChart,
  Trophy,
  LayoutDashboard,
  ScanFace,
  TrendingDown,
  TrendingUp,
  UserCheck,
  ArrowLeftRight,
  History,
  Gift,
  MessagesSquare,
  UserCog,
  Settings,
  type LucideIcon,
} from "lucide-react";

export interface TraderNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Optional badge text shown on the right (e.g. status count). */
  badge?: string;
}

/**
 * Trader sidebar — mirrors the standard user-side sections
 * (1–20). Unfinished routes fall through to a stub page until the
 * feature ships.
 */
export const traderNav: TraderNavItem[] = [
  { label: "Dashboard", to: "/trader/dashboard", icon: LayoutDashboard },
  { label: "Trade", to: "/trader/trade", icon: CandlestickChart },
  { label: "Compete", to: "/trader/compete", icon: Trophy },
  { label: "Trade History", to: "/trader/history", icon: History },
  { label: "My Profile", to: "/trader/profile", icon: UserCog },
  { label: "Banks", to: "/trader/banks", icon: Building2 },
  { label: "Deposit Funds", to: "/trader/deposit", icon: TrendingUp },
  { label: "Withdraw Funds", to: "/trader/withdraw", icon: TrendingDown },
  { label: "Fund Transfer", to: "/trader/fund-transfer", icon: ArrowLeftRight },
  { label: "Bonus & Loyalty", to: "/trader/bonus", icon: Gift },
  { label: "Become an IB", to: "/trader/become-ib", icon: UserCheck },
  { label: "KYC Verification", to: "/trader/kyc", icon: ScanFace },
  { label: "Support Tickets", to: "/trader/support", icon: MessagesSquare },
  { label: "Account Settings", to: "/trader/account-settings", icon: Settings },
];
